<template>
<div class="casespace-index" v-loading="loading">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{spaceTitle}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="activeIndex < tabsData.length">{{tabsData[activeIndex].title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="casespace-tabs" v-if="!loading">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabsData" :key="index" :name="item.tag">
                <span class="tab-font" slot="label">
                    <span :class="activeName===item.tag ? item.tag + ' tab-icon active' : item.tag + ' tab-icon'"></span>
                    {{item.title}}
                </span>
            </el-tab-pane>
            <keep-alive>
                <div :is="tabsData[activeIndex].componentName" :ref="tabsData[activeIndex].componentName" @changeTab="handleClick"></div>
            </keep-alive>
        </el-tabs>
        <template>
            <div class="closecase-btn" v-if="!isManage">
                <el-button type="primary" v-if="!isClosed && isWorker" @click="handleCloseRoom">结束案件</el-button>
                <el-button type="primary" v-if="isClosed && isWorker" @click="handleOpenRoom">开启案件</el-button>
            </div>
        </template>
    </div>
</div>
</template>

<script>
import {
    getStore,
    setStore,
    setStoreSession,
    removeStore
} from '@/utils/utils.js'
import {
    getCaseStatus,
    closeMeetingSecond,
    updateCsaeStatus,
    closeMeeting
} from '@/api/login.js'
import deepClone from 'clone-deep'
import { caseInfoApi } from "@/api/casespace.js";
import {getUserSignAndEmail} from "../../api/user";
import {isManageRole} from "../../utils/utils";
export default {
    components: {
        caseInfo: (resolve) =>
            require(["@/views/caseSpace/components/caseInfo.vue"], resolve),
        evidence: (resolve) =>
            require(["@/views/caseSpace/components/evidence.vue"], resolve),
        quesList: (resolve) =>
            require(["@/views/caseSpace/components/quesList.vue"], resolve),
        asyncChat: (resolve) =>
            require(["@/views/caseSpace/components/asyncChat.vue"], resolve),
        documentList: (resolve) =>
            require(["@/views/caseSpace/components/documentList.vue"], resolve),
        makeDocment: (resolve) =>
            require(["@/views/caseSpace/components/makeDocment.vue"], resolve),
        makeList: (resolve) =>
            require(["@/views/caseSpace/components/makeList.vue"], resolve),
        sendList: (resolve) =>
            require(["@/views/caseSpace/components/sendList.vue"], resolve),
        receiveList: (resolve) => // 当事人接收列表
            require(["@/views/caseSpace/components/receiveList.vue"], resolve),
        attachmentList: (resolve) => // 附件列表
            require(["@/views/caseSpace/components/attachmentList.vue"], resolve),
    },
    props: {},
    data() {
        return {
            loading: true,
            tabsData: [{
                title: "案件信息",
                componentName: "caseInfo",
                tag: "first"
            }],
            tabsDataOrigin: [
                {
                    title: "案件信息",
                    componentName: "caseInfo",
                    tag: "first"
                },
                {
                    title: "问题单",
                    componentName: "quesList",
                    spaceType: 0,
                    tag: "second"
                },
                {
                    title: "举证质证",
                    spaceType: 0,
                    componentName: "evidence",
                    tag: "third"
                },
                {
                    title: "文书列表",
                    spaceType: 0,
                    componentName: "documentList",
                    tag: "fourth"
                },
                {
                    title: "文书生成",
                    spaceType: 1,
                    componentName: "makeDocment",
                    tag: "sixth"
                },
                {
                    title: "文书列表",
                    spaceType: 1,
                    componentName: "makeList",
                    tag: "seventh"
                },
                {
                    title: "文书送达",
                    spaceType: 2,
                    componentName: "sendList",
                    tag: "eighth"
                }, {
                    title: "文书列表",
                    componentName: "receiveList",
                    spaceType: 3,
                    tag: "ninth"
                },
                {
                    title: "我的群聊",
                    componentName: "asyncChat",
                    tag: "fiveth"
                },
                {
                    title: "附件列表",
                    componentName: "attachmentList",
                    tag: "tenth"
                }
            ],
            activeName: "",
            activeIndex: 0,
            isClosed: false,
            spaceType: 0, // 默认0  0异步庭审   1异步调解   2在线送达
            spaceTitle: '异步庭审',
            isManage: false,
            isWorker: false
        };
    },
    created() {
        if (this.$route.query.flk) {
            if (!this.$route.query.caseid || !this.$route.query.meetingid) {
                this.$message.error('参数不合法!')
                this.$router.replace({
                    path: '/loginworker'
                });
            }
        }
        this.veriMeetingStatus()
        let loginInfo = JSON.parse(getStore('loginInfo'))
        this.isManage = isManageRole(loginInfo.userRoles)
        if(loginInfo){
            this.isWorker = loginInfo.personType === 'STAFF'
        }
        this.activeName = this.tabsData[0].tag;
    },
    mounted() {
        if (this.$route.query.flk) {
            removeStore('loginInfo');
            //第三方链接跳转调用
            this.getLogin()
        }
        if (this.$route.query.activeName) {
            this.activeName = this.$route.query.activeName
            this.activeIndex = this.$route.query.activeIndex
        }
        let loginInfo = JSON.parse(getStore('loginInfo'))
        if(loginInfo){
            this.isWorker = loginInfo.personType === 'STAFF'
        }
        this.isClosed = this.$route.query.isClosed == 'true' ? true : false
        localStorage.setItem('CloseState', this.isClosed)
    },
    watch: {},
    methods: {
        async veriMeetingStatus() {
            await getCaseStatus({
                caseId: this.$route.query.caseid,
                meetingId: this.$route.query.meetingid
            }).then((r) => {
                if (r.data.code === 1000) {
                    // this.$message.error('当前异步庭审已结束!')
                    // removeStore('loginInfo');
                    // removeStore('loginInfouser');
                    // removeStore('loginInfoEnterprise');
                    // this.$router.replace({
                    //     path: '/loginworker'
                    // });
                    if (r.data.data.mediationStatus != 'RUNNING') {
                        this.isClosed = true
                    } else {
                        this.isClosed = false
                    }
                    localStorage.setItem('CloseState', this.isClosed)
                } else {
                    this.$message.error(r.data.message)
                }
            })
            caseInfoApi({meetingId: this.$route.query.meetingid}).then((res) => {
                let data = res.data.data.mediationMeetingRes;
                if (data.mediationMeetingType === 'ASYNCHRONOUS_MEDIATE') {
                    this.spaceTitle = '异步调解'
                    this.spaceType = 1
                } else if (data.mediationMeetingType === 'ONLINE_SERVICE') {
                    this.spaceTitle = '在线送达'
                    this.spaceType = 2
                }

                if (this.isWorker) {
                    this.tabsData = deepClone(this.tabsDataOrigin)
                    for (let index=this.tabsData.length-1; index>0; index--) {
                        let item = this.tabsData[index]
                        if (item.spaceType !== undefined && item.spaceType !== this.spaceType) {
                            this.tabsData.splice(index, 1)
                        }
                    }
                } else {
                    let list = deepClone(this.tabsDataOrigin)
                    if (this.spaceType == 0) {
                        this.tabsData = [list[0], list[1], list[2], list[3], list[8], list[9]]
                    } else {
                        // 普通用户只能查看文书
                        getUserSignAndEmail({roomId: this.$route.query.meetingid}).then(userRes => {
                            if (userRes.data.code == 1000) {
                                let data = userRes.data.data
                                let loginInfo = JSON.parse(getStore('loginInfo'));
                                loginInfo.email = data.signatureFileName
                                setStore('loginInfo', loginInfo);

                                if (data.signatureFileName) {
                                    this.tabsData = [list[7], list[8], list[9]]
                                } else {
                                    this.tabsData = [list[7]]
                                }
                            }
                        })
                    }
                }

                this.changeRouterPath()

                this.loading = false
            })
        },
        getLogin() {
            let loginInfo = {
                personType: "STAFF",
                memberId: this.$route.query.userId,
                caseId: this.$route.query.caseid,
                meetingId: this.$route.query.meetingid,
                roomId: this.$route.query.roomid,
                loginName: null,
                mobilePhone: "19900000000",
                idCard: null,
                memberName: "仲裁员",
                headPortraitUrl: null,
                isRealName: false,
                isFacialVerify: false,
                email: null,
                servicePersonStatus: "ONLINE",
                sex: null,
                petitionLetterAgentFlag: false,
                roleType: null,
                defaultPwdFla: false,
                status: null,
                userRoles: [{
                    roleName: "仲裁员",
                    roleCode: "MEDIATOR",
                    roleType: "MEDIATOR",
                    organizationId: 1000036,
                    organizationName: "广州市仲裁委",
                    areaCode: null,
                    areaFullName: null,
                    remark: null,
                    platformCodes: null,
                    addressInfoDTO: null
                }],
                userMenuInfo: []
            }
            let workerInfo = JSON.parse(getStore('loginInfo_worker'))
            if (workerInfo) {
                loginInfo.userRoles = workerInfo.userRoles
            }

            console.log(loginInfo)
            setStore('flk', this.$route.query.flk);
            setStoreSession('haslogin', 'yes');
            setStore('loginInfo', loginInfo);
        },
        getRouter() {
            // if (this.$route.query.activeName) {
            //     this.activeName = this.$route.query.activeName
            // }
        },
        handleClick(tab) {
            console.log(tab)
            if (tab.activeName) this.activeName = tab.activeName
            let that = this
            let index = parseInt(tab.index);
            let hasSubmitQuesListSuccessFlag = getStore('hasSubmitQuesListSuccessFlag')
            console.log(hasSubmitQuesListSuccessFlag)
            if (this.spaceType ==0 && this.activeIndex == 1 && index !== 1 && this.isWorker === false && !this.isClosed && hasSubmitQuesListSuccessFlag !== 'true') {
                // 从问题单切换到别的tab页面
                this.$confirm('问题单未一键提交，如忘记提交请提交后再离开；若下次提交可以先离开，内容将自动保存，下次继续编写。', '温馨提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '去保存',
                    cancelButtonText: '继续离开'
                }).then(() => {
                    console.log('----点击了去保存')
                    this.activeIndex = 1
                    this.activeName = 'second'
                    this.$refs['quesList'].saveAllQuestion()
                }).catch(action => {
                    console.log('----点击了继续离开')
                    this.activeIndex = index
                    this.changeRouterPath()
                    this.$refs['quesList'].saveAllQuestion()
                })
            } else {
                this.activeIndex = index
                // this.activeName=tab.name
                this.changeRouterPath()
            }
            console.log(this.activeName)
        },
        changeRouterPath() {
            let loginInfouser = JSON.parse(getStore('loginInfo'));
            if (loginInfouser.hasOwnProperty('personType') && loginInfouser.personType == 'STAFF') {
                this.$router.replace({
                    path: `/caseSpace?roomid=${this.$route.query.roomid}&activeName=${this.activeName}&activeIndex=${this.activeIndex}&caseid=${this.$route.query.caseid}&meetingid=${this.$route.query.meetingid}&flk=${this.$route.query.flk}&userId=${this.$route.query.userId}&isClosed=${this.isClosed}&spaceType=${this.spaceType}`
                })
            } else {
                this.$router.replace({
                    path: `/caseSpace?roomid=${this.$route.query.roomid}&activeName=${this.activeName}&activeIndex=${this.activeIndex}&caseid=${this.$route.query.caseid}&meetingid=${this.$route.query.meetingid}&token=${this.$route.query.token}&memberId=${this.$route.query.memberId}&memberName=${this.$route.query.memberName}&memberType=${this.$route.query.memberType}&isClosed=${this.isClosed}&spaceType=${this.spaceType}`
                })
            }
        },
        isClosedIndex(value) {
            this.isClosed = value;
        },
        handleOpenRoom() {
            updateCsaeStatus({
                meetingId: this.$route.query.meetingid,
                mediationStatus: 'RUNNING'
            }).then(res => {
                if (res.data.code === 1000) {
                    this.veriMeetingStatus()
                }
            })
        },
        handleCloseRoom() {
            //关闭案件
            this.$confirm(
                    '<i class="sign-icon-warning"></i>结束后, 将不再允许对话，是否继续?',
                    "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        customClass: "close-mediate-room",
                        dangerouslyUseHTMLString: true,
                        center: true,
                    }
                )
                .then(() => {
                    if (this.spaceType == 0) {
                        closeMeeting({
                            meetingId: this.$route.query.meetingid,
                        }).then(
                            (res) => {
                                if (res.data.code === 1000) {
                                    this.$router.push({
                                        path: "/loginworker",
                                    });
                                    this.$message({
                                        message: "已结束案件",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.data.message,
                                    });
                                }
                            },
                            (err) => {}
                        );
                    } else {
                        closeMeetingSecond({
                            meetingId: this.$route.query.meetingid,
                        }).then(
                            (res) => {
                                if (res.data.code === 1000) {
                                    this.$router.push({
                                        path: "/loginworker",
                                    });
                                    this.$message({
                                        message: "已结束案件",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: res.data.message,
                                    });
                                }
                            },
                            (err) => {}
                        );
                    }
                })
                .catch(() => {});
        },
    },
    beforeDestroy() {},
};
</script>

<style lang="scss">
.casespace-index {
    height: 100%;
    padding: 0 40px;

    .el-breadcrumb {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        font-size: 18px;

        .el-breadcrumb__item:last-child .el-breadcrumb__inner {
            color: #333333;
            font-weight: bold;
        }

        .el-breadcrumb__inner {
            color: #999;
        }

        .pointer {
            cursor: pointer;
        }
    }

    .casespace-tabs {
        background-color: #ffffff;
        position: relative;
        min-height: calc(100% - 60px);
    }

    .el-tabs {
        .el-tabs__header {
            padding: 17px 0 14px 5%;
            box-shadow: 0px 6px 6px 0px rgba(0, 33, 94, 0.1);
            border-radius: 4px;

            .el-tabs__nav-wrap::after {
                background-color: #ffffff;
            }

            .el-tabs__item {
                margin: 0 7%;

                .tab-icon {
                    width: 42px;
                    height: 40px;
                }

                .first {
                    background: url("~@/assets/casespace/caseindex_caseInfo.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_caseInfo_hilight.png") no-repeat center;
                    }
                }

                .second {
                    background: url("~@/assets/casespace/caseindex_ques.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_ques_hilight.png") no-repeat center;
                    }
                }

                .third {
                    background: url("~@/assets/casespace/caseindex_evidence.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_evidence_hilight.png") no-repeat center;
                    }
                }

                .fourth {
                    background: url("~@/assets/casespace/caseindex_documentList.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_documentList_hilight.png") no-repeat center;
                    }
                }

                .fiveth {
                    background: url("~@/assets/casespace/caseindex_asyncChat.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_asyncChat_hilight.png") no-repeat center;
                    }
                }

                .sixth {
                    background: url("~@/assets/casespace/caseindex_makeDocument.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_makeDocument_hilight.png") no-repeat center;
                    }
                }

                .seventh {
                    background: url("~@/assets/casespace/caseindex_documentList.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_documentList_hilight.png") no-repeat center;
                    }
                }

                .eighth {
                    background: url("~@/assets/casespace/caseindex_sendDocument.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_sendDocument_hilight.png") no-repeat center;
                    }
                }

                .ninth {
                    background: url("~@/assets/casespace/caseindex_documentList.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_documentList_hilight.png") no-repeat center;
                    }
                }

                .tenth {
                    background: url("~@/assets/casespace/caseindex_attachmentList.png") no-repeat center;

                    &.active {
                        background: url("~@/assets/casespace/caseindex_attachmentList_hilight.png") no-repeat center;
                    }
                }

                &:hover {
                    .first {
                        background: url("~@/assets/casespace/caseindex_caseInfo_hilight.png") no-repeat center;
                    }

                    .second {
                        background: url("~@/assets/casespace/caseindex_ques_hilight.png") no-repeat center;
                    }

                    .third {
                        background: url("~@/assets/casespace/caseindex_evidence_hilight.png") no-repeat center;
                    }

                    .fourth {
                        background: url("~@/assets/casespace/caseindex_documentList_hilight.png") no-repeat center;
                    }

                    .fiveth {
                        background: url("~@/assets/casespace/caseindex_asyncChat_hilight.png") no-repeat center;
                    }

                    .sixth {
                        background: url("~@/assets/casespace/caseindex_makeDocument_hilight.png") no-repeat center;
                    }

                    .seventh {
                        background: url("~@/assets/casespace/caseindex_documentList_hilight.png") no-repeat center;
                    }

                    .eighth {
                        background: url("~@/assets/casespace/caseindex_sendDocument_hilight.png") no-repeat center;
                    }

                    .ninth {
                        background: url("~@/assets/casespace/caseindex_documentList_hilight.png") no-repeat center;
                    }

                    .tenth {
                        background: url("~@/assets/casespace/caseindex_attachmentList_hilight.png") no-repeat center;
                    }
                }
            }
        }

        .el-tabs__active-bar {
            background-color: #ffffff;
        }

        .tab-icon {
            display: block;
            margin: 0 auto;
        }
    }

    .closecase-btn {
        position: absolute;
        right: 34px;
        top: 29px;

        .el-button {
            color: #fff;
        }
    }
}

//去蓝色边框
.el-tabs__item:focus.is-active.is-focus:not(:active) {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.el-message-box.close-mediate-room {
    .el-message-box__header {
        padding: 21px 30px;
        border-bottom: none;
    }

    .el-message-box__content {
        padding: 30px 25px;
    }

    .el-message-box__btns {
        padding: 0px;

        .el-button--small {
            width: 120px;
            height: 40px;
            font-size: 14px;
        }

        .el-button+.el-button {
            margin-left: 40px;
        }
    }

    i.sign-icon-warning {
        display: block;
        margin: 0 auto 20px;
        width: 56px;
        height: 56px;
        background: url("~@/assets/images/ico-sign_warning.png");
    }
}
</style>
